import '../stylus/webar.styl'

$(document).ready(function () {
    $('.experience-link').on('click',
        function(){
           var ar = $(this).data('ar');
           var ismobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
           
           if(ismobile){
               $('#' + ar + '-experience-btn').click();
           }else{
               window.location.href = '/ar_experience/' + ar;
           }
        }
    );
});
